import './utils/axiosInterceptor';
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import './utils/i18n'
import { Provider } from "react-redux";
import store from "./redux/store/store";
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; 

// Add error handler
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
  if (event.error?.message?.includes('older version of React')) {
    console.log('Problematic component:', event.filename, event.lineno);
  }
});


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.unregister(); 